/* Lea Toronto cart drawer: replaces the Kaching Cart app. Markup in snippets/lt-cart.liquid, styles in
   assets/lt-cart.css. Everything goes through Shopify's Ajax Cart API; the free gift + bundle bar
   (assets/lt-gift-bar.js) mounts itself at the top of .lt-cart__contents and keeps the gift line in sync.
   The theme's own drawer is never shown: its open() is pointed at this one. */
(function () {
  var root = document.getElementById('lt-cart');
  if (!root) return;

  var CFG = window.LT_CART || {};
  var CART_CALL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var TIMER_KEY = 'lt-cart-timer-end';
  var TIMER_MS = 10 * 60 * 1000;
  var WIDE = window.matchMedia('(min-width: 1000px)');

  var el = {
    count: root.querySelector('[data-lt-count]'),
    timer: root.querySelector('[data-lt-timer] strong'),
    flash: root.querySelector('[data-lt-flash]'),
    items: root.querySelector('[data-lt-items]'),
    codeForm: root.querySelector('[data-lt-code-form]'),
    codeMsg: root.querySelector('[data-lt-code-msg]'),
    codes: root.querySelector('[data-lt-codes]'),
    savings: root.querySelector('[data-lt-savings]'),
    subtotal: root.querySelector('[data-lt-subtotal]'),
    total: root.querySelector('[data-lt-total]'),
    checkout: root.querySelector('[data-lt-checkout]'),
    side: root.querySelector('[data-lt-upsell-side]'),
    inline: root.querySelector('[data-lt-upsell-inline]'),
    close: root.querySelector('.lt-cart__close')
  };

  var TAG_ICON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6.6.8h4.6v4.6l-5.5 5.5a.9.9 0 0 1-1.3 0L1.1 7.6a.9.9 0 0 1 0-1.3z" fill="currentColor"/><circle cx="8.9" cy="3.1" r="1" fill="#fff"/></svg>';
  var TRASH_ICON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 4h11M6 4V2.5h4V4M4 4l.7 9.5h6.6L12 4M6.8 6.5V11M9.2 6.5V11"/></svg>';

  var cart = null;
  var products = {};        // handle -> product JSON, for the colour/size selects on cart lines
  var productRequests = {};
  var upsell = { anchor: undefined, list: null, sig: '' };
  var loadTimer = null;
  var flashTimer = null;
  var ticker = null;
  var memTimerEnd = 0;
  var lastFocus = null;

  // ---------- helpers ----------

  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amount = (Math.round(cents) / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function uniq(list) {
    var out = [];
    list.forEach(function (v) { if (v != null && out.indexOf(v) === -1) out.push(v); });
    return out;
  }

  function each(nodes, fn) { Array.prototype.forEach.call(nodes, fn); }

  function isGift(item) {
    var props = item.properties || {};
    for (var k in props) if (/^_gift_tier_/.test(k) && props[k]) return true;
    return false;
  }

  function request(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function errorText(err) {
    return (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
  }

  function flash(msg) {
    el.flash.textContent = msg;
    el.flash.hidden = false;
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { el.flash.hidden = true; }, 5000);
  }

  // ---------- loading ----------

  function load() {
    return request('/cart.js').then(function (c) {
      cart = c;
      render();
      return c;
    }).catch(function () {});
  }

  // Coalesce the bursts of cart calls (ours, the theme's, the gift bar's) into one refresh.
  function scheduleLoad() {
    clearTimeout(loadTimer);
    loadTimer = setTimeout(load, 150);
  }

  // ---------- rendering ----------

  function render() {
    if (!cart) return;
    var n = cart.item_count;
    el.count.textContent = n ? '• ' + n : '';
    each(document.querySelectorAll('.cart-link__count'), function (c) { c.textContent = n; });
    root.classList.toggle('is-empty', !n);
    renderItems();
    renderFooter();
    renderUpsell();
  }

  function renderItems() {
    if (!cart.items.length) {
      el.items.innerHTML =
        '<div class="lt-cart__empty"><p>Your cart is empty</p>' +
        '<button type="button" class="lt-cart__empty-btn" data-lt-close>Continue shopping</button></div>';
      return;
    }
    el.items.innerHTML = cart.items.map(itemHtml).join('');
  }

  function linePrices(item) {
    // line_price already has order-level discounts (the bundle %) taken off; final_line_price does not.
    var was = item.original_line_price;
    var now = Math.min(item.final_line_price, item.line_price);
    return { was: was, now: now, off: was > now ? Math.round((was - now) * 100 / was) : 0 };
  }

  function itemHtml(item) {
    var gift = isGift(item);
    var p = linePrices(item);
    var img = sized(item.image, 180);
    if (!gift && !item.product_has_only_default_variant) fetchProduct(item.handle);
    return (
      '<div class="lt-item' + (gift ? ' lt-item--gift' : '') + '" data-key="' + esc(item.key) + '">' +
        '<a class="lt-item__img" href="' + esc(item.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '') +
        '</a>' +
        '<div class="lt-item__info">' +
          '<a class="lt-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (gift ? '<p class="lt-item__note">Free gift</p>' : optionsHtml(item) + qtyHtml(item)) +
        '</div>' +
        '<div class="lt-item__side">' +
          (p.off ? '<s class="lt-item__was">' + money(p.was) + '</s>' : '') +
          '<span class="lt-item__now">' + (p.now === 0 ? 'FREE' : money(p.now)) + '</span>' +
          (p.off ? '<span class="lt-badge">' + TAG_ICON + 'You save ' + p.off + '%</span>' : '') +
          (gift ? '' : '<button type="button" class="lt-item__remove" data-lt-remove aria-label="Remove ' + esc(item.product_title) + ' from cart">' + TRASH_ICON + '</button>') +
        '</div>' +
      '</div>'
    );
  }

  function optionsHtml(item) {
    if (item.product_has_only_default_variant || !item.options_with_values || !item.options_with_values.length) return '';
    var current = item.options_with_values;
    var product = products[item.handle];
    var selects = current.map(function (opt, i) {
      if (!product) {
        // Until the product data arrives, show the current choice.
        return '<select class="lt-select" disabled aria-label="' + esc(opt.name) + '"><option>' + esc(opt.value) + '</option></select>';
      }
      var values = uniq(product.variants.map(function (v) { return v.options[i]; }));
      return '<select class="lt-select" data-lt-option="' + i + '" aria-label="' + esc(opt.name) + '">' +
        values.map(function (val) {
          return '<option' + (val === opt.value ? ' selected' : '') + '>' + esc(val) + '</option>';
        }).join('') +
        '</select>';
    }).join('');
    var names = current.map(function (o) { return o.name; }).join(', ');
    return '<p class="lt-item__opt-names">' + esc(names) + ':</p><div class="lt-item__selects">' + selects + '</div>';
  }

  function qtyHtml(item) {
    return '<div class="lt-qty">' +
      '<button type="button" data-lt-step="-1" aria-label="Decrease quantity">−</button>' +
      '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity" data-lt-qty>' +
      '<button type="button" data-lt-step="1" aria-label="Increase quantity">+</button>' +
      '</div>';
  }

  function fetchProduct(handle) {
    if (products[handle] || productRequests[handle]) return;
    productRequests[handle] = true;
    request('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      products[handle] = p;
      if (cart) renderItems();
    }).catch(function () {});
  }

  function renderFooter() {
    el.subtotal.innerHTML = money(cart.total_price);
    el.total.innerHTML = money(cart.total_price);

    var saved = cart.original_total_price - cart.total_price;
    var titles = [];
    function add(t) { if (t && titles.indexOf(t) === -1) titles.push(t); }
    (cart.cart_level_discount_applications || []).forEach(function (d) { add(d.title); });
    cart.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application && a.discount_application.title); });
    });
    el.savings.hidden = saved <= 0;
    el.savings.innerHTML = saved > 0
      ? '<span>You save</span><span class="lt-cart__savings-badges">' +
          titles.map(function (t) { return '<span class="lt-chip" title="' + esc(t) + '">' + TAG_ICON + '<span>' + esc(t) + '</span></span>'; }).join('') +
        '</span><span class="lt-cart__savings-amount">' + money(saved) + '</span>'
      : '';

    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
    el.codes.innerHTML = codes.map(function (c) {
      return '<button type="button" class="lt-chip" data-lt-code="' + esc(c.code) + '" aria-label="Remove discount code ' + esc(c.code) + '">' +
        TAG_ICON + '<span>' + esc(c.code) + '</span><span aria-hidden="true">×</span></button>';
    }).join('');
  }

  // ---------- "Frequently bought together" ----------

  function anchorProductId() {
    for (var i = 0; i < cart.items.length; i++) if (!isGift(cart.items[i])) return cart.items[i].product_id;
    return null;
  }

  function normalize(p) {
    var optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var variants = (p.variants || []).map(function (v) {
      return {
        id: v.id,
        available: v.available !== false,
        price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price,
        options: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
      };
    });
    var image = p.featured_image || (p.images && p.images[0]) || '';
    if (image && typeof image === 'object') image = image.src || '';
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/);
    return { id: p.id, title: p.title, url: '/products/' + p.handle, tags: tags, image: image, optionNames: optionNames, variants: variants };
  }

  function usable(p) {
    return p.tags.indexOf(CFG.giftTag) === -1 && p.variants.some(function (v) { return v.available; });
  }

  function loadUpsell(anchor) {
    var recs = anchor
      ? request('/recommendations/products.json?product_id=' + anchor + '&limit=10&intent=related')
          .then(function (r) { return r.products || []; })
          .catch(function () { return []; })
      : Promise.resolve([]);
    recs.then(function (list) {
      list = list.map(normalize).filter(usable);
      if (list.length >= 4) return list;
      return request('/collections/' + (CFG.fallbackCollection || 'best-sellers') + '/products.json?limit=20')
        .then(function (r) { return list.concat((r.products || []).map(normalize).filter(usable)); })
        .catch(function () { return list; });
    }).then(function (list) {
      if (upsell.anchor !== anchor) return;
      var seen = {};
      upsell.list = list.filter(function (p) { return seen[p.id] ? false : (seen[p.id] = true); });
      upsell.sig = '';
      if (cart) renderUpsell();
    });
  }

  function renderUpsell() {
    var wide = WIDE.matches;
    var target = wide ? el.side : el.inline;
    var other = wide ? el.inline : el.side;
    other.hidden = true;
    other.innerHTML = '';

    var anchor = cart.items.length ? anchorProductId() : null;
    if (anchor !== upsell.anchor) {
      upsell.anchor = anchor;
      upsell.list = null;
      if (anchor) loadUpsell(anchor);
    }
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var list = (upsell.list || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 8);

    // Rebuilding the cards resets their selects, so only redraw when the list really changed.
    var sig = (wide ? 'w' : 'n') + list.map(function (p) { return p.id; }).join(',');
    if (sig === upsell.sig && !target.hidden === !!list.length) return;
    upsell.sig = sig;
    target.hidden = !list.length;
    target.innerHTML = list.length
      ? '<p class="lt-upsell__title">Frequently bought together</p><div class="lt-upsell__list">' + list.map(cardHtml).join('') + '</div>'
      : '';
  }

  function cardHtml(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0];
    var single = p.variants.length === 1 && (!v.options.length || /^default title$/i.test(v.options[0]));
    return '<div class="lt-upsell__card" data-product="' + p.id + '">' +
      '<a class="lt-upsell__img" href="' + esc(p.url) + '"><img src="' + esc(sized(p.image, 200)) + '" alt="' + esc(p.title) + '" width="80" height="80" loading="lazy"></a>' +
      '<a class="lt-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<p class="lt-upsell__price" data-lt-up-price>' + money(v.price) + '</p>' +
      (single ? '' : p.optionNames.map(function (name, i) {
        var values = uniq(p.variants.map(function (x) { return x.options[i]; }));
        return '<label class="lt-upsell__opt"><span>' + esc(name) + ':</span>' +
          '<select class="lt-select" data-lt-up-option="' + i + '">' +
          values.map(function (val) { return '<option' + (val === v.options[i] ? ' selected' : '') + '>' + esc(val) + '</option>'; }).join('') +
          '</select></label>';
      }).join('')) +
      '<button type="button" class="lt-upsell__add" data-lt-up-add data-variant="' + v.id + '">Add to cart</button>' +
      '</div>';
  }

  function upsellProduct(card) {
    var id = Number(card.getAttribute('data-product'));
    return (upsell.list || []).filter(function (p) { return p.id === id; })[0];
  }

  // ---------- actions ----------

  function itemByKey(key) {
    return cart ? cart.items.filter(function (i) { return i.key === key; })[0] : null;
  }

  // Shopify re-keys a line when its discounts change (e.g. the bundle % steps up), so a key read at
  // render time can be stale by the time it is used: look the line up again, by variant if need be.
  function changeLine(key, qty) {
    return request('/cart.js').then(function (c) {
      var hit = c.items.filter(function (i) { return i.key === key; })[0];
      if (!hit) {
        var variant = Number(String(key).split(':')[0]);
        hit = c.items.filter(function (i) { return i.variant_id === variant && !isGift(i); })[0];
      }
      if (!hit) return null;
      return request('/cart/change.js', { id: hit.key, quantity: qty });
    });
  }

  function setQty(row, qty) {
    row.classList.add('is-busy');
    changeLine(row.getAttribute('data-key'), qty)
      .catch(function (err) { flash(errorText(err)); })
      .then(load);
  }

  function changeVariant(row) {
    var item = itemByKey(row.getAttribute('data-key'));
    var product = item && products[item.handle];
    if (!product) return;
    var chosen = Array.prototype.map.call(row.querySelectorAll('[data-lt-option]'), function (s) { return s.value; });
    var match = product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];
    if (!match || !match.available) {
      flash('Sorry, that combination is sold out.');
      renderItems();
      return;
    }
    if (match.id === item.variant_id) return;
    row.classList.add('is-busy');
    // Add the new variant first, so a failed add never loses the customer's item.
    request('/cart/add.js', { items: [{ id: match.id, quantity: item.quantity, properties: item.properties || {} }] })
      .then(function () { return changeLine(item.key, 0); })
      .catch(function (err) { flash(errorText(err)); })
      .then(load);
  }

  function setCodes(list, added) {
    el.codeForm.classList.add('is-busy');
    return request('/cart/update.js', { discount: list.join(',') })
      .then(function (c) {
        if (!added) return;
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === added.toLowerCase(); })[0];
        if (hit && hit.applicable) {
          showCodeMsg('');
          el.codeForm.elements.code.value = '';
          return;
        }
        showCodeMsg(hit ? 'This code can’t be used with the items in your cart.' : 'Enter a valid discount code.');
        // Drop the code that did not apply so it does not linger on the cart.
        return request('/cart/update.js', { discount: list.filter(function (x) { return x !== added; }).join(',') });
      })
      .catch(function () { showCodeMsg('Something went wrong. Please try again.'); })
      .then(function () {
        el.codeForm.classList.remove('is-busy');
        return load();
      });
  }

  function showCodeMsg(msg) {
    el.codeMsg.textContent = msg;
    el.codeMsg.hidden = !msg;
  }

  function appliedCodes() {
    return (cart && cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
  }

  // ---------- countdown ----------

  function timerEnd() {
    var end = memTimerEnd;
    try { end = Number(sessionStorage.getItem(TIMER_KEY)) || end; } catch (e) {}
    if (!end || end <= Date.now()) {
      end = Date.now() + TIMER_MS;
      try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    memTimerEnd = end;
    return end;
  }

  function tick() {
    var s = Math.max(0, Math.ceil((timerEnd() - Date.now()) / 1000));
    var mm = Math.floor(s / 60);
    var ss = s % 60;
    el.timer.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
  }

  // ---------- open / close ----------

  function open() {
    if (root.classList.contains('is-open')) {
      scheduleLoad();
      return;
    }
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lt-cart-lock');
    tick();
    clearInterval(ticker);
    ticker = setInterval(tick, 1000);
    load();
    setTimeout(function () { try { el.close.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lt-cart-lock');
    clearInterval(ticker);
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // ---------- events ----------

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-lt-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var row = t.closest('.lt-item');
    var step = t.closest('[data-lt-step]');
    if (row && step) {
      var input = row.querySelector('[data-lt-qty]');
      setQty(row, Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-lt-step'))));
      return;
    }
    if (row && t.closest('[data-lt-remove]')) {
      setQty(row, 0);
      return;
    }
    var chip = t.closest('[data-lt-code]');
    if (chip) {
      var code = chip.getAttribute('data-lt-code');
      setCodes(appliedCodes().filter(function (c) { return c !== code; }));
      return;
    }
    var addBtn = t.closest('[data-lt-up-add]');
    if (addBtn && !addBtn.disabled) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      request('/cart/add.js', { items: [{ id: Number(addBtn.getAttribute('data-variant')), quantity: 1 }] })
        .catch(function (err) {
          flash(errorText(err));
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        })
        .then(load);
      return;
    }
    if (t.closest('[data-lt-checkout]')) {
      el.checkout.classList.add('is-loading');
      window.location.href = '/checkout';
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    var row = t.closest('.lt-item');
    if (row && t.matches('[data-lt-qty]')) {
      setQty(row, Math.max(0, parseInt(t.value, 10) || 0));
      return;
    }
    if (row && t.matches('[data-lt-option]')) {
      changeVariant(row);
      return;
    }
    if (t.matches('[data-lt-up-option]')) {
      var card = t.closest('.lt-upsell__card');
      var p = card && upsellProduct(card);
      if (!p) return;
      var chosen = Array.prototype.map.call(card.querySelectorAll('[data-lt-up-option]'), function (s) { return s.value; });
      var v = p.variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      var btn = card.querySelector('[data-lt-up-add]');
      if (v && v.available) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        btn.setAttribute('data-variant', v.id);
        card.querySelector('[data-lt-up-price]').innerHTML = money(v.price);
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
    }
  });

  el.codeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = el.codeForm.elements.code.value.trim();
    if (!code) return;
    var list = appliedCodes();
    if (list.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) !== -1) {
      showCodeMsg('This code is already applied.');
      return;
    }
    setCodes(list.concat(code), code);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // The header cart icon opens this drawer instead of the theme's drawer or the cart page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.cart-link, a[href="/cart"], a[href="/cart/"]');
    if (!a || root.contains(a) || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // The theme's product forms call .open() on its own drawer after "Add to cart"; send those here.
  function takeOverThemeDrawer() {
    each(document.querySelectorAll('.js-cart-drawer, cart-drawer'), function (d) {
      d.open = function () { open(); };
    });
  }
  takeOverThemeDrawer();
  document.addEventListener('DOMContentLoaded', takeOverThemeDrawer);
  document.addEventListener('theme:open-cart-drawer', function (e) {
    e.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('on:cart:add', open);

  // The gift bar announces when it has swapped the gift line.
  document.addEventListener('cart:refresh', scheduleLoad);

  // Refresh after any cart change made elsewhere on the page (theme, apps, the gift bar).
  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : a && a.url;
    var res = origFetch.apply(this, arguments);
    if (typeof url === 'string' && CART_CALL.test(url)) res.then(scheduleLoad, function () {});
    return res;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_CALL.test(url)) this.addEventListener('load', scheduleLoad);
    return origOpen.apply(this, arguments);
  };

  var onWide = function () { upsell.sig = ''; if (cart) renderUpsell(); };
  if (WIDE.addEventListener) WIDE.addEventListener('change', onWide);
  else if (WIDE.addListener) WIDE.addListener(onWide);

  // Coming back from checkout with the browser's back button restores the page as it was.
  window.addEventListener('pageshow', function () { el.checkout.classList.remove('is-loading'); });

  window.LTCart = { open: open, close: close, refresh: load };
})();